import { useState } from "react";
import SectionHeading from "@/components/feature/SectionHeading";
import type { FaqItem } from "@/mocks/faq";

interface FaqSectionProps {
  items: FaqItem[];
  kicker?: string;
  title?: string;
  desc?: string;
}

export default function FaqSection({
  items,
  kicker = "FAQ",
  title = "常见问题",
  desc = "关于热帖榜、神回复和投稿方式，你可能会想知道的几件事。",
}: FaqSectionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="w-full bg-background-100 border-y border-background-200">
      <div className="max-w-content mx-auto px-4 md:px-8 py-14 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
          <div className="lg:col-span-4">
            <SectionHeading kicker={kicker} title={title} desc={desc} />
          </div>
          <div className="lg:col-span-8">
            <div className="divide-y divide-background-300/70 border-t border-b border-background-300/70">
              {items.map((item, index) => {
                const open = openIndex === index;
                return (
                  <div key={item.q}>
                    <h3>
                      <button
                        type="button"
                        onClick={() => setOpenIndex(open ? null : index)}
                        aria-expanded={open}
                        className="w-full flex items-center justify-between gap-4 py-5 text-left cursor-pointer group"
                      >
                        <span className="text-sm md:text-base font-medium text-foreground-900 group-hover:text-primary-700 transition-colors">
                          {item.q}
                        </span>
                        <span
                          className={`shrink-0 w-8 h-8 rounded-full flex items-center justify-center transition-colors ${
                            open
                              ? "bg-primary-500 text-background-50"
                              : "bg-background-200 text-foreground-600"
                          }`}
                        >
                          <i className={open ? "ri-subtract-line" : "ri-add-line"}></i>
                        </span>
                      </button>
                    </h3>
                    {open && (
                      <p className="pb-5 pr-12 text-sm text-foreground-600 leading-relaxed animate-fade-up">
                        {item.a}
                      </p>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}